// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f319b77f","238":"3fbe9860","239":"9e8c8a03","667":"8e0cbbb7"}[chunkId] + ".chunk.js";
};